import { useEffect, useState } from "react";
import {
  getLivestreamSchedulePhase,
  type LivestreamSchedulePhase,
} from "./livestreamSchedule";

export function useLivestreamScheduleClock({
  start,
  end,
}: {
  start?: string | null;
  end?: string | null;
}) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  return {
    now,
    phase: getLivestreamSchedulePhase({ start, end, now }),
  };
}

export function useLivestreamSchedulePhase({
  start,
  end,
}: {
  start?: string | null;
  end?: string | null;
}): LivestreamSchedulePhase {
  return useLivestreamScheduleClock({ start, end }).phase;
}
